import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: false,
};

const NotificationSlicer = createSlice({
  name: "akaNotificationSlicer",
  initialState,
  reducers: {
    NotificationReducer: (state: boolean | any, { payload }: boolean | any) => {
      state.data = payload;
    },
  },
});
export const { NotificationReducer } = NotificationSlicer.actions;
export default NotificationSlicer.reducer;
